import React, { useEffect, useState, useMemo } from 'react';
import { Calendar, momentLocalizer, Event as RBCEvent } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Dashboard } from '../../../../../models/Dashboard/Dashboard';
import { UpcomingEvent } from '../../../../../models/Dashboard/contracts';
import styles from './DashboardCalendar.module.scss';

const localizer = momentLocalizer(moment);

interface CalendarEvent extends RBCEvent {
  type: 'pickup' | 'return';
  orderId: number;
  orderNumber: number;
  customer: string;
}

const eventColors = {
  pickup: '#3fa7d6', // blue
  return: '#dab94f' // gold
};

const DashboardCalendar: React.FC = () => {
  const [events, setEvents] = useState<CalendarEvent[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    Dashboard.getUpcomingEvents()
      .then((data) => {
        setEvents(
          data.map((e) => ({
            title: `${e.event_type === 'pickup' ? 'Preuzimanje' : 'Vraćanje'}: ${e.customer_name} (#${e.order_number})`,
            start: new Date(e.event_date),
            end: new Date(e.event_date),
            allDay: false,
            type: e.event_type,
            orderId: e.order_id,
            orderNumber: e.order_number,
            customer: e.customer_name
          }))
        );
      })
      .finally(() => setLoading(false));
  }, []);

  // Custom event style for dark theme
  const eventPropGetter = (event: CalendarEvent) => ({
    style: {
      backgroundColor: eventColors[event.type],
      color: '#171f20',
      borderRadius: '6px',
      border: 'none',
      fontWeight: 600,
      fontSize: '0.95rem',
      padding: '2px 6px',
      boxShadow: '0 2px 6px #0002'
    }
  });

  // Custom dark theme wrapper
  const calendarClass = styles.darkCalendar || '';

  return (
    <div className={calendarClass} style={{ minHeight: 500, background: '#171f20', borderRadius: 8, padding: 16 }}>
      <h3 style={{ color: '#e9e9e9', marginBottom: 16, marginTop: 16  }}> Kalendar Preuzimanja i Vraćanja</h3>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 450, background: 'transparent', color: '#e9e9e9' }}
        eventPropGetter={eventPropGetter}
        popup
        tooltipAccessor={null}
        onSelectEvent={(event: CalendarEvent) => {
          window.open(`/admin/orders/${event.orderId}`, '_blank');
        }}
        messages={{
          today: 'Danas',
          previous: 'Nazad',
          next: 'Napred',
          month: 'Mesec',
          week: 'Nedelja',
          day: 'Dan',
          agenda: 'Agenda',
          date: 'Datum',
          time: 'Vreme',
          event: 'Događaj',
          noEventsInRange: 'Nema događaja u ovom periodu.'
        }}
      />
    </div>
  );
};

export default DashboardCalendar; 